<template>
	<!-- `checkout-marketing-opt-out` is an unstyled hook for template CSS. -->
	<div
		class="checkout-marketing-opt-out flex flex-col gap-3 text-sm text-gray-700"
	>
		<p>
			{{ $t("checkout.marketing_opt_out.disclaimer") }}
			<i18n-t
				v-if="privacyPolicyUrl"
				keypath="checkout.marketing_opt_out.privacy"
				tag="span"
			>
				<template #link>
					<a
						:href="privacyPolicyUrl"
						target="_blank"
						rel="noopener noreferrer"
						class="underline hover:no-underline"
					>
						{{ $t("checkout.marketing_opt_out.privacy_link") }}
					</a>
				</template>
			</i18n-t>
		</p>
		<SharedCheckbox
			id="checkout-marketing-opt-out"
			:model-value="optedOut"
			:content="$t('checkout.marketing_opt_out.label')"
			:disabled="isSaving"
			@update:model-value="handleOptOutChange"
		/>
		<p v-if="hasError" role="alert" class="text-red-600">
			{{ $t("checkout.marketing_opt_out.error") }}
		</p>
	</div>
</template>

<script setup lang="ts">
import type { Order } from "@nwt/norce-pwa/dist/runtime/types/api/checkout/orders/orders";

const props = defineProps<{ order: Order | null }>();

const { t } = useI18n();
const privacyPolicyUrl =
	(useRuntimeConfig().public.privacyPolicyUrl as string) || "";

// The label is stored on the consent, so the order records what was shown.
const { optedOut, isSaving, hasError, handleOptOutChange } =
	useCheckoutMarketingOptOut(toRef(props, "order"), () =>
		t("checkout.marketing_opt_out.label")
	);
</script>
